import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {TABLET_BREAKPOINT} from '../utils/constants';
import AboveFold from '../components/common/above-fold/AboveFold';
import LinkPilesModule from '../modules/LinkPiles/LinkPilesModule';
import SEOTextModule from '../modules/seo-text/SEOTextModule';
import PopularDestinationsModule from '../modules/PopularDestinations/PopularDestinationsModule';
import PropertyTypesModule from '../modules/PropertyTypes/PropertyTypesModule';
import {AsyncNeighborhoods} from '../modules/Neighborhoods/AsyncNeighborhoods';
import GreatPlacesToStayModule from '../modules/GreatPlacesToStay/GreatPlacesToStayModule';
import {AsyncFamilyFriendly} from '../modules/FamilyFriendly/AsyncFamilyFriendly';
import {DateModal} from '../components/common/date-modal/DateModal';
import {AsyncDestinationUrgency} from '../modules/UrgencyMessage/AsyncDestinationUrgency';
import {AsyncDestinationInfographic} from '../modules/DestinationInfographic/AsyncDestinationInfographic';
import ReviewsModule from '../modules/Review/ReviewsModule';
import DynamicSeoLinkpile from '../components/common/seo-linkpile/DynamicSeoLinkpile';
import ScrollToTopModule from '../modules/ScrollToTop/ScrollToTopModule';
import {AsyncRecentTravelerActivity} from '../modules/RecentTravelerActivity/AsyncRecentTravelerActivity';
import DynamicQuestionsModule from '../modules/DynamicQuestions/DynamicQuestionsModule';
import {TESTS} from '../utils/abacus';
import ValuePropsModule from '../modules/ValueProps/ValuePropsModule';
import {AsyncExploreBookEnjoy} from '../components/destination/explore-book-enjoy/AsyncExploreBookEnjoy';
import {AsyncToaster} from '../components/common/toaster/AsyncToaster';
import {AsyncTripBoardModal} from '../components/common/tripboard/AsyncTripBoardModal';
import {AsyncRecommendedProperties} from '../modules/RecommendedProperties/AsyncRecommendedProperties';
import {AsyncMapProperties} from '../components/destination/map-properties/AsyncMapProperties';
import DynamicDestinationRefinements from '../modules/DynamicDestinationRefinements';
import {PointsOfInterestModule} from '../modules/PointsOfInterest/PointsOfInterestModule';
import {AsyncAATestModule} from '../modules/AATest/AsyncAATestModule';

import {
    fullExposures,
    lazy,
    withErrorBoundary,
    withTripboardsLazy,
    withTripboards,
} from './helpers';
import ContentHubModule from '../modules/ContentHub/ContentHubModule';

export const fullExposureTests = [
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.SLP_TRAFFIC_TEST_AA,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
    TESTS.VRBO_LANDING_SLP_BRANDED_HEADINGS,
    TESTS.VRBO_LANDING_UPDATED_BREADCRUMB,
    TESTS.VRBO_LANDING_UPDATED_BREADCRUMB_SEO,
];

function TemplateComponent(props) {
    const {
        isMobile,
        hasTouch,
        dispatch,
        showDynamicDestinationRefinements,
        showPlaceholders,
        showGreatPlacesToStay,
        showPoiMap,
        reportPoiExperiment,
    } = props;

    useEffect(() => {
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }, [dispatch, isMobile, hasTouch]);

    const mainCSSClass = classNames('app-main', {
        'container--loading__visible': showPlaceholders,
    });

    return (
        <>
            <main className={mainCSSClass}>
                {fullExposures([...fullExposureTests])}
                <AboveFold />
                {lazy(<ScrollToTopModule />)}
                {withTripboardsLazy(<AsyncRecentTravelerActivity />)}
                {withTripboardsLazy(<AsyncRecommendedProperties />)}
                {showDynamicDestinationRefinements &&
                    lazy(<DynamicDestinationRefinements />)}
                {lazy(<AsyncDestinationUrgency />)}
                {withErrorBoundary(<PopularDestinationsModule />)}
                {withErrorBoundary(<PropertyTypesModule />)}
                {withErrorBoundary(<AsyncNeighborhoods />)}
                {showPoiMap
                    ? lazy(
                          <PointsOfInterestModule
                              reportPoi={reportPoiExperiment}
                          />
                      )
                    : lazy(
                          <AsyncMapProperties reportPoi={reportPoiExperiment} />
                      )}
                {lazy(<AsyncAATestModule />)}
                {withTripboardsLazy(<AsyncFamilyFriendly />)}
                {showGreatPlacesToStay &&
                    withTripboards(<GreatPlacesToStayModule />)}
                {withTripboards(<ReviewsModule />)}
                {lazy(<AsyncDestinationInfographic />)}
                {lazy(<ValuePropsModule />)}
                {lazy(<AsyncExploreBookEnjoy />)}
                {withErrorBoundary(<SEOTextModule />)}
                {withErrorBoundary(<DynamicQuestionsModule />)}
                {withErrorBoundary(<ContentHubModule />)}
                {withErrorBoundary(<LinkPilesModule />)}
                {withErrorBoundary(<DateModal />)}
            </main>
            {withErrorBoundary(<DynamicSeoLinkpile />)}
            {withErrorBoundary(<AsyncToaster />)}
            {withErrorBoundary(<AsyncTripBoardModal />)}
        </>
    );
}

export function mapStateToProps({pointsOfInterest, options}) {
    return {
        showDynamicDestinationRefinements:
            options.destinationRefinementsMode !== 'disabled',
        showPlaceholders: options.showPlaceholders,
        showGreatPlacesToStay: options.showGreatPlacesToStay,
        showPoiMap: pointsOfInterest.hasData && options.showPoiMap,
        reportPoiExperiment:
            pointsOfInterest.hasData && options.reportPoiExperiment,
    };
}

export const Template = connect(mapStateToProps)(
    determineIfMobile(TemplateComponent, TABLET_BREAKPOINT)
);

Template.displayName = 'Template';

export default Template;
